import { CSVLink } from 'react-csv';
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import MinusRoundIcon from "@rsuite/icons/MinusRound";

import {
  crossSellOpportunityData,
} from "../../services/interfaces/ICrossSellOpportunity";
import { Fragment, useState } from 'react';
import { numberFormatter } from '../../utils/formatter';
import { Pagination } from "rsuite";
import { number } from 'yargs';


const CrossSellOpportunityDetails = ({ crossellDataCopy, crossellTotalData, onCustomerSelect, onItemSelect, crossellItemLevelDataCopy,
  pageNumber, updatePageNumber, selectedCustomerId, selectedPeer, selectedItem,
  updateSelectedCustomerId, updateSelectedPeer, updateSelectedItem,
}: any) => {


  const [limit, setLimit] = useState(10);

  const removeLeadingZero = (n: any) => {
    let newStr = n?.replace(/^0+/, "");
    return newStr;
  };

  return (
    <>
      <table className="supplierTable customerSummaryTable text-black">
        <thead>
          <tr>
            <th className='table-header-text'>Customer ID</th>
            <th className='table-header-text'>CustomerName</th>
            <th className='table-header-text'>Peer Group</th>
            {selectedCustomerId && <th className='table-header-text'>Category</th>}
            {selectedPeer && <th className='table-header-text'>Item ID</th>}
            {selectedPeer && <th className='table-header-text'>Item Description</th>}
            <th className='table-header-text'>Cross Sell Opportunity</th>
          </tr>
        </thead>
        <tbody>
          {crossellDataCopy?.length > 0 ? (
            Array.isArray(crossellDataCopy) &&
            crossellDataCopy?.map((d: any, index: any) => {
              return (
                <Fragment key={d.customer + "_" + index}>
                  <tr
                    key={d.customer}
                    className={`${selectedCustomerId !== d.customer && selectedCustomerId !== null ? "low-opacity" : ""
                      }`}
                  >
                    <td className='table-cell-text'>
                      <div className="flex">
                        {selectedCustomerId === d.customer ? (
                          <MinusRoundIcon
                            className="plusIcon"
                            onClick={() => {
                              updateSelectedCustomerId(null);
                              updateSelectedPeer(null);

                            }}
                          />
                        ) : (
                          <PlusRoundIcon
                            className="plusIcon"
                            onClick={() => {
                              updateSelectedCustomerId(d.customer);
                              updateSelectedPeer(null);
                              onCustomerSelect({ customer: d?.customer, peerGroupname: d.peerGroupname })
                            }}
                          />
                        )}
                        <div>{removeLeadingZero(d.customer)}</div>
                      </div>
                    </td>

                    <td className='table-cell-text'>{d.customername}</td>
                    <td className='table-cell-text'>{d.peerGroupname}</td>
                    {selectedCustomerId && <td className='table-cell-text'></td>}
                    {selectedPeer && <td className='table-cell-text'></td>}
                    {selectedPeer && <td className='table-cell-text'></td>}

                    <td className='table-cell-text'>{numberFormatter(d.OpportunityMargin, 0, "$")}</td>
                  </tr>
                  {selectedCustomerId === d.customer &&
                    crossellItemLevelDataCopy &&
                    (crossellItemLevelDataCopy).map((item: any, dIndex: any) => {
                      return (
                        <>
                          <tr
                            key={`${d.customer}_${item.peerGroupName}`}
                            className={`${selectedPeer !== `${d.customer}_${item.l3}` && selectedPeer !== null ? "low-opacity" : ""
                              }`}
                          >
                            <td className='table-cell-text'></td>
                            <td className='table-cell-text'></td>
                            <td className='table-cell-text'></td>
                            <td className='table-cell-text'>
                              <div className="flex">
                                {selectedPeer ===
                                  `${d.customer}_${item.l3}` ? (
                                  <MinusRoundIcon
                                    className="plusIcon"
                                    onClick={() => {
                                      updateSelectedPeer(null);
                                      // updateSelectedItem(null);
                                    }}
                                  />
                                ) : (
                                  <PlusRoundIcon
                                    className="plusIcon"
                                    onClick={() => {
                                      updateSelectedPeer(
                                        `${d.customer}_${item.l3}`
                                      );

                                    }}
                                  />
                                )}
                                <div>{item.l3}</div>
                              </div>
                            </td>
                            {selectedPeer && <td className='table-cell-text'></td>}
                            {selectedPeer && <td className='table-cell-text'></td>}
                            <td className='table-cell-text'>
                              {numberFormatter(item.OpportunityMargin, 0, "$")}
                            </td>
                          </tr>
                          {selectedPeer === `${d.customer}_${item.l3}` &&
                            item.itemData.map((lis: any, lIndex: any) => {
                              return (
                                <>
                                  <tr
                                    key={`${lis.peerGroupName}_${lIndex}`}
                                    className={`${selectedItem !== lis?.itemid && selectedItem !== null ? "low-opacity" : ""
                                      }`}
                                  >
                                    <td className='table-cell-text'></td>
                                    <td className='table-cell-text'></td>
                                    <td className='table-cell-text'></td>
                                    <td className='table-cell-text'></td>
                                    <td onClick={() => {
                                      onItemSelect(lis?.itemid);
                                      updateSelectedItem(lis?.itemid);
                                    }} className='table-cell-text  cursor-pointer'>
                                      {lis?.itemImage !== 'NA' && lis?.itemImage && <img src={lis?.itemImage} alt="item-logo"
                                        className='w-[7vh] h-[6vh] mb-[.5vh]'
                                      />}
                                      {removeLeadingZero(lis?.itemid)}
                                    </td>
                                    <td className='table-cell-text'>{lis?.itemDesc}</td>
                                    <td className='table-cell-text'>
                                      {numberFormatter(
                                        lis?.itemLevelOpportunity,
                                        0,
                                        "$"
                                      )}
                                    </td>
                                  </tr>

                                </>
                              );
                            })}
                        </>
                      );
                    })}
                </Fragment>
              );
            })
          ) : (
            <tr>
              <td
                colSpan={9}
                className="table-cell-text text-black"
                style={{ textAlign: "center" }}
              >
                {" "}
                No Data Available
              </td>
            </tr>
          )}
          <tr className="total-row">
            <td className="table-cell-text bg-deloitteGreen">Total</td>
            <td className="table-cell-text bg-deloitteGreen"></td>
            <td className="table-cell-text bg-deloitteGreen"></td>
            {selectedCustomerId && <td className="table-cell-text bg-deloitteGreen"></td>}
            {selectedPeer && <><td className="table-cell-text bg-deloitteGreen"></td><td className="table-cell-text bg-deloitteGreen"></td></>}
            <td className="table-cell-text bg-deloitteGreen">
              {numberFormatter(crossellTotalData?.OpportunityMargin, 0, "$")}
            </td>
          </tr>
        </tbody>
      </table>
      <div className="pagination-component">
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["-", "pager", "skip"]}
          total={crossellTotalData?.totalCount}
          limit={limit}
          activePage={pageNumber}
          onChangePage={(e) => {
            updatePageNumber(Number(e));
            updateSelectedCustomerId(null);
            updateSelectedPeer(null);
            updateSelectedItem(null);
          }}
        />
      </div>
    </>
  );
};

export default CrossSellOpportunityDetails;
